import { Button, Col, Form, Input, Row, Select } from "antd";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import useGet from "../../../global/hooks/useGet";
import CustomDateTimePicker from "../../../global/components/inputWidgets/CustomDatePicker";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { HiArrowPath } from "react-icons/hi2";
import {
  getDealerNo,
  getOemNo,
  hasRole,
} from "../../../global/hooks/getUserRole";
import {
  booleanOptions,
  orderLicenseTypeOptions,
  orderPayTypeOptions,
  orderTypeOptions,
} from "../../../utils/Common";
import dayjs from "dayjs";
import { useEffect } from "react";
import { FaFileAlt } from "react-icons/fa";

export const OrderFilter = ({
  filter,
  handleFilterChange,
  handleFilter,
  handleReset,
  setFilter,
  params,
  onSiteRegReport,
}) => {
  const [form] = Form.useForm();
  const modParams = { ...Object.fromEntries([...params?.entries()]) } || {}; //

  const handleFormChange = (changedValues, allValues) => {
    // Update filter state when form values change
    Object.keys(changedValues).forEach((key) => {
      if (key === "Month") {
        const formattedMonth = changedValues[key]
          ? dayjs(changedValues[key]).format("YYYY-MM")
          : null;
        setFilter({ ...filter, Month: formattedMonth });
      } else if (key === "OrderTime") {
        setFilter({ ...filter, OrderTime: changedValues[key] });
      }
    });
  };

  useEffect(() => {
    const formValues = {};

    if (modParams?.Month) {
      formValues.Month = dayjs(modParams.Month, "YYYY-MM");
    }

    if (modParams?.OrderTime) {
      formValues.OrderTime = dayjs.unix(Number(modParams.OrderTime));
    }

    // Set form values without triggering onChange
    if (Object.keys(formValues).length > 0) {
      form.setFieldsValue(formValues);
    }
  }, [params]);

  const optionUrl = `${process.env.REACT_APP_API_URL}/api/devices/options/`;

  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);
  const optionCodesUrl = `${process.env.REACT_APP_API_URL}/api/licensecodes/getoptions/`;

  const {
    data: optionCodesData,
    loading: optionCodesDataLoading,
    error: optionCodesDataError,
  } = useGet(optionCodesUrl);

  const dealerOptionsUrl = filter?.OemNo
    ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${filter?.OemNo}/dealers/`
    : !hasRole(1, 2, 3) && getOemNo()
      ? `${process.env.REACT_APP_API_URL}/api/dealers/oems/${getOemNo()}/dealers/`
      : null;

  const {
    data: dealerOptions,
    loading: dealerOptionsLoading,
    error: dealerOptionsError,
  } = useGet(dealerOptionsUrl);

  const custmerOptionsUrl = filter?.DealerNo
    ? `${process.env.REACT_APP_API_URL}/api/dealers/${filter?.DealerNo}/customers/`
    : !hasRole(1, 2, 3, 4, 5, 6) && getDealerNo()
      ? `${process.env.REACT_APP_API_URL}/api/dealers/${getDealerNo()}/customers/`
      : null;

  const {
    data: custmerOptions,
    loading: custmerOptionsLoading,
    error: custmerOptionsError,
  } = useGet(custmerOptionsUrl);

  const modifiedItems = getModifiedResponse(optionCodesData, "items");
  const modifiedOems = getModifiedResponse(optionData, "oems");
  const modifiedDealer = getModifiedResponse(dealerOptions, null);
  const modifiedCustomers = getModifiedResponse(custmerOptions, null);

  return (
    <Form className="" form={form} onValuesChange={handleFormChange}>
      <div className="mt-2">
        <Row gutter={[16, 16]}>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="OrderNo"
              placeholder="No"
              value={filter.OrderNo}
              onChange={handleFilterChange}
            />
          </Col> */}
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <CustomDateTimePicker
              name="OrderTime"
              placeholder="Order Time"
              format="YYYY-MM-DD HH:mm" // 24-hour format
            />
          </Col>
          {hasRole(1, 2, 3) ? (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="OEM"
                optionFilterProp="label"
                value={
                  filter.OemNo || typeof filter.OemNo === "number"
                    ? Number(filter.OemNo)
                    : null
                }
                onChange={(value) => setFilter({ ...filter, OemNo: value })}
                options={modifiedOems}
                style={{ width: "100%" }}
                allowClear
              />
            </Col>
          ) : (
            <></>
          )}
          {hasRole(1, 2, 3, 4, 5, 6) ? (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Dealer"
                optionFilterProp="label"
                value={filter.DealerNo ? Number(filter.DealerNo) : undefined}
                onChange={(value) => setFilter({ ...filter, DealerNo: value })}
                options={modifiedDealer}
                style={{ width: "100%" }}
                allowClear
                disabled={
                  hasRole(4, 5, 6)
                    ? false
                    : filter.OemNo === undefined ||
                      filter.OemNo === null ||
                      filter.OemNo === ""
                }
              />
            </Col>
          ) : (
            <></>
          )}
          {!hasRole(9, 10, 11, 12) ? (
            <Col xs={24} sm={24} md={12} lg={8} xl={6}>
              <Select
                showSearch
                placeholder="Customer"
                optionFilterProp="label"
                value={
                  filter.CustomerNo ? Number(filter?.CustomerNo) : undefined
                }
                onChange={(value) =>
                  setFilter({ ...filter, CustomerNo: value })
                }
                options={modifiedCustomers}
                style={{ width: "100%" }}
                allowClear
                disabled={
                  hasRole(7, 8, 9)
                    ? false
                    : filter.DealerNo === undefined ||
                      filter.DealerNo === null ||
                      filter.DealerNo === ""
                }
              />
            </Col>
          ) : (
            <></>
          )}
          <Col xs={24} sm={24} md={12} lg={8} xl={6} className="!h-[32px]">
            <Input
              className="input_text_3 mr10 !h-full"
              name="Mac"
              placeholder="MAC"
              value={filter.Mac}
              onChange={handleFilterChange}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="Order Type"
              optionFilterProp="label"
              value={
                typeof filter.OrderType === "number"
                  ? Number(filter.OrderType)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, OrderType: value })}
              options={orderPayTypeOptions}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="License Item"
              optionFilterProp="label"
              value={
                typeof filter.LicenseItem === "number"
                  ? Number(filter.LicenseItem)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, LicenseItem: value })}
              options={modifiedItems}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="License Type"
              optionFilterProp="label"
              value={
                typeof filter.LicenseType === "number"
                  ? Number(filter.LicenseType)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, LicenseType: value })}
              options={orderLicenseTypeOptions}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="Free"
              optionFilterProp="label"
              value={
                filter.Free || filter.Free === 0
                  ? Number(filter.Free)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, Free: value })}
              options={booleanOptions}
              style={{ width: "100%" }}
            />
          </Col>
        </Row>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="flex justify-between my-4 flex-nowrap min-w-[610px]">
          <div className="flex items-center">
            <Button
              type="primary"
              className="mr-2 w-[104px] h-[30px] font-medium"
              onClick={handleFilter}
            >
              <IoIosCheckmarkCircleOutline className="!text-[14px] font-medium" />
              Apply
            </Button>
            <Button
              className="reset-button !mr-2"
              onClick={() => {
                form.resetFields();
                handleReset();
              }}
            >
              <HiArrowPath className="!text-[14px] font-medium" />
              Reset
            </Button>
            <Button
              type="primary"
              className="w-[220px] h-[30px] font-medium"
              onClick={onSiteRegReport}
            >
              <FaFileAlt className="!text-[14px] font-medium" />
              On Site Registration Report
            </Button>
          </div>
        </div>
      </div>
    </Form>
  );
};
